export const LV_ShipmentTypeTR={
ShTyID:{en:'ShTyID',cs:'ShTyID',dataType:'number',format:'#0',required:true},
ShTyName:{en:'Type',cs:'Stav',dataType:'string',required:true,maxLength:255}
}